import { createActions } from 'redux-actions';
import keyGenerator from 'utils/keys';
import types from 'state/loads/actionTypes';

const { loads } = createActions({
  [types.CHANGE_LOAD_VALUES]: ({ values, shipmentKey, loadKey }) => ({
    values,
    shipmentKey,
    loadKey,
  }),
  [types.ADD_LOAD]: ({ shipmentKey = 0, loadKey, values = {} }) => ({
    shipmentKey,
    loadKey: `${loadKey || keyGenerator.timestamp()}`,
    values,
  }),
  [types.REMOVE_LOAD]: ({ shipmentKey = 0, loadKey }) => ({
    shipmentKey,
    loadKey,
  }),
  [types.deleteLoad$]: ({ shipmentKey, loadKey }) => ({
    shipmentKey,
    loadKey,
  }),

  [types.createLoad$]: ({ shipmentKey = 0 }) => ({
    shipmentKey,
  }),

  [types.changeLoadValue$]: ({
    field,
    value,
    shipmentKey,
    loadKey,
    maxItemsInLoad,
  }) => ({
    field,
    value,
    shipmentKey,
    loadKey,
    maxItemsInLoad,
  }),
  [types.changePalletType$]: ({ field, value, shipmentKey, loadKey }) => ({
    field,
    value,
    shipmentKey,
    loadKey,
  }),
  [types.changeNonPalletType$]: ({ field, value, shipmentKey, loadKey }) => ({
    field,
    value,
    shipmentKey,
    loadKey,
  }),
  [types.changeLoadType$]: ({ field, value, shipmentKey, loadKey }) => ({
    field,
    value,
    shipmentKey,
    loadKey,
  }),
  [types.onBlurLoadValue$]: ({ field, shipmentKey, loadKey }) => ({
    field,
    shipmentKey,
    loadKey,
  }),
  [types.onFocusLoadValue$]: ({ field, shipmentKey, loadKey }) => ({
    field,
    shipmentKey,
    loadKey,
  }),
  [types.validateForm$]: () => ({}),

  [types.setForTest]: () => ({}),
});

export default loads;
